import { Button, Stack, Typography } from "@mui/material";
import { useThemePalette } from "common/hooks/theme_palette";
import React from "react";
import { useTranslation } from "react-i18next";

const FormHeader = ({ handleModelClose, form, formikData, refsubmit }) => {
  const { red, primary } = useThemePalette();
  const { t } = useTranslation();
  return (
    <Stack
      flexDirection="row"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="space-between"
      borderBottom="1px solid rgb(217, 217, 217) "
    >
      <Typography fontSize="32px" fontWeight="700" fontFamily="Cairo">
        {form?.title}
      </Typography>
      <Stack
        my={2}
        flexDirection="row"
        gap={2}
        className={form?.className?.actionButton}
      >
        {/* add custom header, add cancel, save to it */}
        <Button
          onClick={(e) => {
            handleModelClose();
          }}
          variant="outlined"
          sx={{
            color: red,
            borderColor: red,
            "&:hover": {
              borderColor: red,
            },
          }}
        >
          {t("vendors.action_cancel")}
        </Button>
        <Button
          onClick={() => refsubmit?.current?.click()}
          variant="contained"
          sx={{
            backgroundColor: primary,
            "&:hover": {
              backgroundColor: primary,
            },
          }}
        >
          {form?.submitTitle ? form?.submitTitle : "Save Changes"}
        </Button>
      </Stack>
    </Stack>
  );
};

export default FormHeader;
